<h1 mat-dialog-title>
    <app-titulo-paginas
        titulo="Histórico de Pacientes do Profissional {{data?.pessoa ? data?.pessoa?.nome : data?.nome | uppercase}}">
    </app-titulo-paginas>
</h1>
<mat-dialog-content>
    <div class="row">
        <div class="col-lg-4">
            <span class="fas fa-user"></span><strong> Prestador:
            </strong>
            <p>{{data?.pessoa ? data?.pessoa?.nome : data?.nome | uppercase}}</p>
        </div>
        <div class="col-lg-4">
            <span class="fas fa-user"></span><strong> Formação:
            </strong>
            <p>{{data?.formacao}}</p>
        </div>
        <div class="col-lg-4">
            <span class="fas fa-user"></span><strong> Cidade:
            </strong>
            <p>{{data.cidade}} - {{data?.uf}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="btn-group">
                <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="viewDateChange.next(viewDate)"
                    (click)="buscaEscalaDosProfissionaisPorIdPaciente()">
                    Anterior
                </div>
                <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate"
                    (viewDateChange)="viewDateChange.next(viewDate)"
                    (click)="buscaEscalaDosProfissionaisPorIdPaciente()">
                    Hoje
                </div>
                <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="viewDateChange.next(viewDate)"
                    (click)="buscaEscalaDosProfissionaisPorIdPaciente()">
                    Próximo
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <h3>{{ viewDate | calendarDate: 'month' + 'ViewTitle':'PT' | uppercase }}
            </h3>
        </div>
        <div class="col-md-4">
            <div class="btn-group">
                <div class="btn btn-primary" style="background-color: #1e90ff; border: #1e90ff">
                    D = DIURNO
                </div>
                <div class="btn btn-primary" style="background-color: #ad2121; border: #ad2121">
                    N = NOTURNO
                </div>
                <div class="btn btn-warning" style="background-color: #e3bc08; border: #e3bc08">
                    F = Folga
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-lg-12">
        <div class="alert alert-info">
            <div class="panel-heading">
                <span class="glyphicon glyphicon-user"></span><strong> Profissional:
                </strong>{{data?.pessoa ? data?.pessoa?.nome : data?.nome | uppercase }}
            </div>
        </div>
    </div> -->
    <mat-tab-group>
        <mat-tab label="Pacientes">
            <mat-list>
                <div mat-subheader>Pacientes</div>
                <div *ngIf="loadingPacientes">
                    <div class="text-center">
                        <i class="fa fa-spin fa-spinner fa-5x"></i> <br />
                        Buscando Profissionais <i class="fas fa-user-md"></i>
                    </div>
                </div>
                <mat-list-item *ngFor="let paciente of profissionais">
                    <mat-icon mat-list-icon>person</mat-icon>
                    <div mat-line>{{paciente.nome | titlecase}}</div>
                </mat-list-item>
            </mat-list>
        </mat-tab>
        <mat-tab label="Lista">
            <div class="table-responsive">
                <table class="table table-striped table-bordered" id="tabela-escala">
                    <thead>
                        <tr>
                            <th>Paciente </th>
                            <th *ngFor="let dia of mes">{{dia}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let prestador of profissionais">
                            <td style="min-width: 300px;">
                                {{prestador.nome | titlecase}}
                            </td>
                            <td *ngFor="let dia of mes">{{verificarDiaEscalaPrestador(prestador.dias, dia)}}</td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="loadingPacientes">
                    <div class="text-center">
                        <i class="fa fa-spin fa-spinner fa-5x"></i> <br />
                        Carregando escalas <i class="fas fa-calendar-alt"></i>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Calendário">
            <div *ngIf="loading">
                <div class="text-center">
                    <i class="fa fa-spin fa-spinner fa-5x"></i> <br />
                    Carregando escalas <i class="fas fa-calendar-alt"></i>
                </div>
            </div>
            <div>
                <div [ngSwitch]="view" #exports>
                    <mwl-calendar-month-view *ngSwitchCase="'month'" [refresh]="refresh" [viewDate]="viewDate"
                        [events]="events" [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
                        (eventClicked)="eventClicked($event.event)">
                    </mwl-calendar-month-view>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" class="btn btn-secondary" (click)="dialogRef.close()">Fechar</button>
</mat-dialog-actions>